import { Select } from '@mantine/core'

import { useQuery } from '@redwoodjs/web'

import { GET_EMAIL_TEMPLATES } from 'src/graphql/emailTemplates.graphql'

import { inlineSelectProps } from './inlineSelectStyles'

const EmailTemplateOptions = ({
  selectedEmailTemplate,
  setSelectedEmailTemplate,
}) => {
  const { data: emailTemplatesList } = useQuery(GET_EMAIL_TEMPLATES, {
    variables: {
      pageInfo: {
        limit: 100,
        offset: 0,
      },
      orderBy: {
        field: 'title',
        direction: 'asc',
      },
    },
  })

  const emailTemplates = emailTemplatesList?.emailTemplates?.items ?? []

  return (
    <div className="flex flex-col gap-3 text-xs">      {emailTemplates.length === 0 ? (
        <div className="text-xs text-doubleNickel-gray-500">
          No email templates found.
        </div>
      ) : (
        <Select
          {...inlineSelectProps}
          value={selectedEmailTemplate?.emailTemplateId}
          onChange={(value) =>
            setSelectedEmailTemplate({ emailTemplateId: value })
          }
          data={emailTemplates.map((t) => ({
            value: t.emailTemplateId,
            label: t.title,
          }))}
          className="max-w-sm"
          searchable
        />
      )}
    </div>
  )
}

export default EmailTemplateOptions
